import type {
  MotionLibraryLoadMode,
  MotionLibraryLoadState,
} from './assetLibraryMotionLibrary';
import type { AssetLibraryDisplayItem } from './utils';

export type AssetLibraryGridViewState = {
  isFallbackMode: boolean;
  isSupplementMode: boolean;
  isMotionLibraryLoading: boolean;
  showNoResultsMotionLibrary: boolean;
  showSupplementDivider: boolean;
  hasGridContent: boolean;
  showLoadMore: boolean;
  doneLoadingAll: boolean;
  isLoadingMoreContent: boolean;
};

export function getAssetLibraryGridViewState(input: {
  displayAssets: AssetLibraryDisplayItem[];
  motionLibraryMode: MotionLibraryLoadMode;
  motionLibraryLoad: MotionLibraryLoadState;
  assetsExhausted: boolean;
  hasMoreAssets: boolean;
  isLoadingMore: boolean;
}): AssetLibraryGridViewState {
  const {
    displayAssets,
    motionLibraryMode,
    motionLibraryLoad,
    assetsExhausted,
    hasMoreAssets,
    isLoadingMore,
  } = input;

  const motionLibraryItems = motionLibraryLoad.items;
  const isFallbackMode = motionLibraryMode === 'fallback';
  const isSupplementMode = motionLibraryMode === 'supplement';
  const isMotionLibraryPending =
    motionLibraryLoad.status === 'pending' || motionLibraryLoad.isLoadingMore;
  const isMotionLibraryLoading =
    (isFallbackMode || isSupplementMode) && isMotionLibraryPending;
  const showNoResultsMotionLibrary =
    isFallbackMode &&
    (isMotionLibraryLoading ||
      motionLibraryItems.length > 0 ||
      motionLibraryLoad.status === 'error' ||
      motionLibraryLoad.status !== 'ready');
  const showSupplementDivider =
    isSupplementMode &&
    displayAssets.length > 0 &&
    (motionLibraryItems.length > 0 || isMotionLibraryPending);
  const hasGridContent =
    displayAssets.length > 0 ||
    motionLibraryItems.length > 0 ||
    isMotionLibraryLoading ||
    showSupplementDivider ||
    showNoResultsMotionLibrary;
  const hasMoreMotionLibrary =
    motionLibraryMode !== 'none' &&
    (motionLibraryLoad.hasMore || motionLibraryLoad.status === 'initial');
  const showLoadMore =
    hasMoreAssets ||
    (assetsExhausted && hasMoreMotionLibrary) ||
    motionLibraryLoad.isLoadingMore;
  const doneLoadingAll =
    assetsExhausted &&
    (motionLibraryMode === 'none' ||
      (motionLibraryLoad.status === 'ready' && !motionLibraryLoad.hasMore));
  const isLoadingMoreContent =
    isLoadingMore || motionLibraryLoad.isLoadingMore;

  return {
    isFallbackMode,
    isSupplementMode,
    isMotionLibraryLoading,
    showNoResultsMotionLibrary,
    showSupplementDivider,
    hasGridContent,
    showLoadMore,
    doneLoadingAll,
    isLoadingMoreContent,
  };
}
